import { ModelBase } from '../../core/model/model-base';
import { Address } from '../../common/model/address';

export class Resource extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.address = new Address(dataContext.address);
      this.email = dataContext.email;
      this.name = dataContext.name;
      this.phone = dataContext.phone;
      this.competences = dataContext.competences;
      this.enableAccess = dataContext.enableAccess;
      this.hasAccount = dataContext.hasAccount;
      this.lastLogin = dataContext.lastLogin;
      this.password = dataContext.password;
    }
    if (!this.address) this.address = new Address();
  }

  id: string;
  address: Address;
  email: string;
  enableAccess: boolean;
  hasAccount: boolean;
  lastLogin: Date;
  name: string;
  password: string;
  phone: string;
  competences: string[];
}
